import { render, staticRenderFns } from "./SendDocument.vue?vue&type=template&id=5b922610"
import script from "./SendDocument.vue?vue&type=script&lang=js"
export * from "./SendDocument.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports